import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  catchError,
  forkJoin,
  map,
  Observable,
  of,
  startWith,
  Subject,
  takeUntil,
} from 'rxjs';
import {
  MatFormField,
  MatFormFieldModule,
  MatLabel,
} from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { UserSessionService } from '../../services/user.service';
import { MatOption, MatSelectModule } from '@angular/material/select';
import {
  MatAutocompleteModule,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import { GestionComptesService } from '../../services/gestion-comptes.service';
import { SnackbarService } from '../../services/snackbar/snackbar.service';
import { SnackbarHelper } from '../../services/snackbar/snackbar.helper';

@Component({
  selector: 'app-filiale-selector',
  standalone: true,
  templateUrl: './filiale-selector.component.html',
  styleUrl: './filiale-selector.component.scss',
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    CommonModule,
    MatFormField,
    FormsModule,
    MatLabel,
    MatOption,
    MatIconButton,
    MatIcon,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
  ],
})
export class FilialeSelectorComponent implements OnInit, OnDestroy {
  selectedFiliale: string = '';
  filialeCtrl = new FormControl('');
  filiales: string[] = [];
  filteredFiliales$!: Observable<string[]>;
  private readonly _destroying$: Subject<void> = new Subject();
  activiteAdherent!: string;

  @ViewChild(MatAutocompleteTrigger)
  autocompleteTrigger!: MatAutocompleteTrigger;

  constructor(
    private readonly userSessionService: UserSessionService,
    private readonly gestionComptesService: GestionComptesService,
    private readonly snackbarService: SnackbarService,
  ) {}
  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }

  ngOnInit(): void {
    const currentUser = localStorage.getItem('currentUserAdmin');
    this.activiteAdherent = this.userSessionService.getActivite();
    const user = currentUser ? JSON.parse(currentUser) : {};

    if (user && user.email) {
      this.gestionComptesService
        .getEnseignesByTitulaire(user.email)
        .pipe(takeUntil(this._destroying$))
        .subscribe({
          next: (enseignes: any[]) => {
            this.filiales = [...new Set(enseignes)];

            if (this.filiales.length === 0) {
              this.selectedFiliale = '';
              this.filialeCtrl.setValue('');
              this.userSessionService.setFiliale(null);
              this.snackbarService.show(
                'Aucune filiale trouvée pour ce compte.',
                SnackbarHelper.snackbarPanelClassError(),
              );
              return;
            }

            this.selectedFiliale = this.filiales[0];
            this.filialeCtrl.setValue(this.selectedFiliale);
            this.userSessionService.setFiliale(this.selectedFiliale);
          },
        });
    }

    // autocomplete
    this.filteredFiliales$ = this.filialeCtrl.valueChanges.pipe(
      startWith(''),
      map((value) => (value ?? '').toString().toLowerCase()),
      map((value) =>
        this.filiales.filter((f) => f.toLowerCase().includes(value)),
      ),
    );
  }

  onFilialeSelected(filiale: string) {
    this.userSessionService.setFiliale(filiale || null);
  }

  onClearFiliale() {
    this.filialeCtrl.setValue('');
    this.userSessionService.setFiliale(null);
  }

  onInputFocus(): void {
    this.autocompleteTrigger.openPanel();
  }
}
